/* ActivityTypeComponent.js */

"use strict";

const BaseActivityViewColumnComponent = require("../BaseActivityViewColumnComponent");
const Renderer = require("./ActivityTypeRenderer");
const _ = require("lodash");

class ActivityTypeColumnComponent extends BaseActivityViewColumnComponent {
    constructor(configOptions) {
        super(configOptions);

        const normalizedActivity = this._normalizeActivity(configOptions);

        this._activityType = _.get(normalizedActivity, "activityType.activityType", "unknown");

        this._renderer = new Renderer(this);

        this._registerListeners();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        this._unregisterListeners();
        return this._renderer._shutdown().then(() => {
            this._renderer = undefined;
            this._activityType = undefined;
        });
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    setValue(newVal) {
        if (!_.isUndefined(newVal.activityType)) {
            this.setActivityType(newVal.activityType);
        }
    }
    getValue() {
        return {
            activityType: this.getActivityType()
        };
    }

    setActivityType(newVal) {
        this._activityType = newVal;
        this.emit("ActivityType", newVal);
        return this;
    }
    getActivityType() {
        return this._activityType;
    }

    static SortFunction(a, b) {
        let aVal = 1,
            bVal = 1;

        if (a[1].activityType === "note") {
            aVal = 1;
        }
        if (a[1].activityType === "system") {
            aVal = 2;
        }
        if (a[1].activityType === "unknown") {
            aVal = 3;
        }
        if (b[1].activityType === "note") {
            bVal = 1;
        }
        if (b[1].activityType === "system") {
            bVal = 2;
        }
        if (b[1].activityType === "unknown") {
            bVal = 3;
        }

        if (aVal > bVal) {
            return 1;
        }
        if (aVal < bVal) {
            return -1;
        }
        return 0;
    }

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = ActivityTypeColumnComponent;
